import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-types-papi';
import { Groups, Props as WidgetProps } from './Groups';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../_partials/WidgetBoxWide';
import getStatLine from '../../../utils/getStatLine';
import EmptyState from '../../EmptyState';
import { URLS } from '@wix/da-url';
import GroupsConfigPopover from './GroupsConfigPopover';

import s from './Groups.scss';

class GroupsBoxWide extends React.Component<
  WidgetProps &
    WidgetBoxWideProps &
    WithTranslation & {
      totalCount?: number;
      isOwner: boolean;
      profileOwnerUser: PapiUser;
    }
> {
  render() {
    const {
      id,
      subHeader,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      totalCount,
      hasMore,
      fetchMore,
      isFetching,
      isEmpty,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      parentRef,
      widgetBoxClassName,
      ...props
    } = this.props;

    return (
      <WidgetBoxWide
        id={id}
        header={props.t!(`widgets.groups_${props.type}.header`)}
        count={totalCount}
        subHeader={getStatLine(props.t!, 'groups', totalCount)}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        hasMore={hasMore}
        fetchMore={fetchMore}
        isFetching={isFetching}
        moduleId={props.moduleId}
        widgetMoveUp={widgetMoveUp}
        parentRef={parentRef}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        widgetMenuRenderer={close => (
          <GroupsConfigPopover moduleId={props.moduleId} onClose={close} />
        )}
        className={widgetBoxClassName}
        isEmpty={isEmpty}
        emptyView={
          props.isOwner ? (
            <EmptyState
              view="small"
              className={classnames(s['empty-state'], s[props.type])}
              title={props.t!(`widgets.groups_${props.type}.empty.title.owner`)}
              subtitle={props.t!(
                `widgets.groups_${props.type}.empty.subtitle.owner`
              )}
              buttonLabel={props.t!(
                `widgets.groups_${props.type}.empty.CTALabel.owner`
              )}
              withButton={true}
              onButtonClick={this.navigateToBrowseGroups}
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!(
                `widgets.groups_${props.type}.empty.title.visitor`,
                {
                  username: props.profileOwnerUser.username,
                }
              )}
              subtitle={props.t!(
                `widgets.groups_${props.type}.empty.subtitle.visitor`,
                {
                  username: props.profileOwnerUser.username,
                }
              )}
            />
          )
        }
      >
        <Groups isWide {...props} />
      </WidgetBoxWide>
    );
  }

  navigateToBrowseGroups() {
    window.location.replace(URLS.GROUPS);
  }
}

export default withTranslation()(GroupsBoxWide) as React.ComponentType<
  Pick<
    WidgetBoxWideProps,
    | 'moduleId'
    | 'id'
    | 'isHeaderStickyOnMobile'
    | 'subHeader'
    | 'headerExtraElementsOnMobile'
  >
>;
